<script setup lang="ts">
const { size = 24, color = '#458C03' } = defineProps<{
  size?: number | string;
  color?: string;
}>();
</script>

<template>
  <svg :width="size" :height="size" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 12.9L10.1429 16.5L18 7.5"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
